"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorScheme = void 0;
const isServer_1 = require("@uxf/core/utils/isServer");
function getColorScheme() {
    if (isServer_1.isServer) {
        return;
    }
    const bodyClassList = document.body.classList;
    if (bodyClassList.contains("light")) {
        return "light";
    }
    if (bodyClassList.contains("dark")) {
        return "dark";
    }
}
exports.getColorScheme = getColorScheme;
